import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { userService } from '../services/api';

const getAuthorRole = (user) => {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  return roles.find(role => role.name?.toLowerCase() === 'author' || role.description?.toLowerCase() === 'author')
    || (user?.role_name?.toLowerCase() === 'author' && user?.role_id ? { id: user.role_id } : null);
};

export const useAuthorContentNavigation = () => {
  const navigate = useNavigate();
  const { user, switchRole } = useUser();

  const navigateToContent = async (contentId = null, state = undefined) => {
    let authorRole = getAuthorRole(user);

    if (!authorRole) {
      const response = await userService.enableAuthorRole();
      const roleId = response?.data?.authorRoleId || response?.data?.roleId;
      authorRole = roleId ? { id: roleId } : null;
    }

    if (!authorRole?.id) {
      const response = await userService.getUserRoles(user?.id);
      const roles = response?.data?.data || response?.data || [];
      authorRole = roles.find(role => role.name?.toLowerCase() === 'author' || role.description?.toLowerCase() === 'author');
    }

    if (!authorRole?.id || !(await switchRole(authorRole.id))) {
      throw new Error('Unable to switch to the Author role');
    }

    // New content always goes to the one add-content screen (K21.2 pts 19, 35); editing opens the form.
    const path = contentId ? `/contents/form/${contentId}` : '/contents/add';
    navigate(path, state === undefined ? undefined : { state });
  };

  return navigateToContent;
};
